import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { TaxRatesSection } from '../../../features/settings/tax-rates-section'

export const Route = createFileRoute('/_app/settings/tax-rates')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'tax-rates'),
  component: TaxRatesSection,
})
